import { getSelectedDates, convert_date_to_timestamp, get_days } from './dates'


export function updateFilterUrl(activeFilters, currentPage, filterView, selectedMarkers){
  let filterUrl = '';
  let count = 0;
  let page = 0;
  
  for (const filter_name in activeFilters) {
    const filter = activeFilters[filter_name],
          filter_values = filter.value.toString();

    if (filter_values.length){
      if (count > 0){
        filterUrl += '&';
      } else {
        filterUrl += '#';
      }
      filterUrl += filter_name + '=' + filter_values;

      count += 1;

    }
  }
  if (count > 0){
    filterUrl += '&page=' + currentPage;
    filterUrl += '&view=' + filterView;
    
  } else {
    filterUrl += '#page=' + currentPage;
    filterUrl += '&view=' + filterView;
  }
  const isEmpty = (obj) => Object.keys(obj).length === 0;

  if (!isEmpty(selectedMarkers)){

    filterUrl += '&map_data=' + JSON.stringify(selectedMarkers);
  }

  window.history.pushState(null, null, filterUrl);
}


export function parseFilterUrl(filterForm, filterSettings, topFilter){

  let hash =  window.location.hash;


  filterForm.forEach((widget) => {
    widget.filters.forEach((filter) => {

      const activeFilter = {
        position: 'side',
        type: filter.type,
        name: filter.name,
        title: filter.title,
        value: filter.name == "search" ? "" : [],
        selectedTitles: [],
        or: filter.or
      }
      filterSettings.activeFilters[filter.name] = activeFilter;
    })
  });



  if (filterSettings.calendarViewEnabled) {

    if (typeof filterSettings.activeFilters.calendar == "undefined"){
      const calendar_filter =
        {
          type: "date",
          name: "calendar",
          title: "Calendar",
          value: [false, false],
          or: false,
        };
      filterSettings.activeFilters["calendar"] = calendar_filter;
    } else {
      filterSettings.activeFilters.calendar.value = [false, false];
    }
  }



  if (Object.keys(topFilter).length != 0 && topFilter.constructor === Object){
    filterSettings.activeFilters["top_filter"] = topFilter;
  }


  if (!hash.length)
    return filterSettings;

  let params = hash.split("#")[1].split("&");
  params.forEach((param, i)=> {
    const v = param.split("=");
    if (v[0] == "page") {
      filterSettings.pagination.currentPage = v[1];
    } else if (v[0] == "view") {
      filterSettings.currentView = v[1];
    } else if (v[0] == "map_data") {
      let map_data = null,
          map_string = decodeURI(v[1])
      try {
         map_data = JSON.parse(map_string);
      } catch (error) {
          map_data = [];
          console.error("Error parsing JSON:", error.message);
      }
      if (map_data){
        filterSettings.map_data = map_data;
      } else {
        filterSettings.map_data = [];
      }
   

    } else {

      if (filterSettings.activeFilters[v[0]]){
        let value = [];
        value = v[1].split(',');
        if (v[0] == "search"  ){
          value = decodeURI(v[1]);
          filterSettings.activeFilters[v[0]].value = value;

        } else if (v[0] == "calendar" ){
          let start_date = decodeURI(value[0]),
          end_date = decodeURI(value[1]);
       
          if (start_date != 'false'){
            start_date = new Date(new Date(start_date).setHours(0,0,0,0));
          } else {
            start_date = false;
          }

          if (end_date != "false"){
            end_date = new Date(new Date(end_date).setHours(0,0,0,0));
          } else {
            end_date = false;
          }

          filterSettings.activeFilters[v[0]].value = [start_date, end_date];
        } else if (v[0] == "top_filter"){
          if (filterSettings.activeFilters[v[0]].type == "date" && v[1] !== "all"){
            filterSettings.activeFilters[v[0]].value = parseInt(v[1]);
          } else {
            filterSettings.activeFilters[v[0]].value = v[1];
          }

      

        } else {


          filterSettings.activeFilters[v[0]].value = value;
          //need to do it this way to maintain correct order. will need to be optimised
          let selectedTitles = [];
          if (typeof value != "undefined"){
            value.forEach((v) => {

              filterForm.forEach((widget) => {
                if (typeof widget.filters != "undefined"){
                  let filters = widget.filters;

                  filters.forEach((filter) => {

                    if (typeof filter.elements != "undefined" && filter.elements.length){
                      let elements = filter.elements;
                      elements.forEach((element) => {
                        if (v == element.value){
                          selectedTitles.push(element.title);

                        }
                      })
                    }


                  })
                }

              })
            })
          }


          filterSettings.activeFilters[v[0]].selectedTitles = selectedTitles;
        }




      }

    }
  });
  return filterSettings;
}
